import Vue from 'vue'
import Vuex from 'vuex'
import options from '../../resource/store/officialWebStore/index'
Vue.use(Vuex)

export default new Vuex.Store(options)
